import { updates } from '@/mocks/home-data';

export default function UpdatesSection() {
  const getTagStyle = (tag: string) => {
    switch (tag) {
      case '更新':
        return 'bg-primary-100 text-primary-700';
      case '上新':
        return 'bg-accent-100 text-accent-700';
      case '活动':
        return 'bg-accent-100 text-accent-700';
      case '升级':
        return 'bg-secondary-100 text-secondary-700';
      case '里程碑':
        return 'bg-accent-100 text-accent-700';
      case '合作':
        return 'bg-secondary-100 text-secondary-700';
      default:
        return 'bg-background-200 text-foreground-600';
    }
  };

  return (
    <section id="updates" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-8">
          最新动态
        </h2>
        <div className="max-w-3xl mx-auto">
          {updates.map((item, index) => (
            <div key={item.id} className="flex items-start gap-4">
              <div className="flex flex-col items-center pt-1">
                <div
                  className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${
                    index === 0 ? 'bg-primary-500 ring-4 ring-primary-100' : 'bg-background-300'
                  }`}
                ></div>
                {index < updates.length - 1 && (
                  <div className="w-px h-8 bg-background-200 my-1"></div>
                )}
              </div>
              <div className="flex-1 pb-5">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-500">{item.date}</span>
                  <span
                    className={`px-2 py-0.5 rounded text-[10px] font-medium ${getTagStyle(item.tag)}`}
                  >
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-800 font-medium leading-relaxed">
                  {item.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}